export default "__VITE_ASSET__h8q8YtKo__"